import React,{useRef, useEffect} from 'react';
import './Contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { BsWhatsapp } from 'react-icons/bs';
import Aos from 'aos';
import "aos/dist/aos.css";
import emailjs from 'emailjs-com';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_rgqyk5b', 'template_gw21n6l', form.current, 'GEd289z1DWoq63ep0')
    
    e.target.reset()
  };

  useEffect(() => {
    Aos.init({duration: 1000});
  },[]);
  
  return (
    <section id="contact" data-aos="zoom-in"> 
      <h5> Get in Touch </h5>
      <h2> Contact Me </h2>

      <div className='container contact__container'>
        <div className=" contact__options">
          <article className='contact__option'>
            <MdOutlineEmail className="contact__option-icon"/>
            <h4> Email</h4>
            <h5> eltonalexander16@gmail.com</h5>
            <a href='mailto:eltonalexander16@gmail.com' target='_blank'> Send a Message </a>
          </article>
          <article className='contact__option'>
            <BsWhatsapp className="contact__option-icon"/>
            <h4> WhatsApp </h4>
            <h5> +2348024036217 </h5>
            <a href='https://api.whatsapp.com/send?phone=+2348024036217' target='_blank'> Send a Message </a>
          </article>
        </div>
        {/*END OF CONTACT OPTIONS*/}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder=" Your Full Name " required />
          <input type ="email" name="email" placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type="submit" className='btn btn-primary'> Send Message </button>
        </form>
      </div>
    </section>
  )
}

export default Contact